import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import NewsSection from "@/pages/home/components/NewsSection";
import SpecialsSection from "@/pages/home/components/SpecialsSection";
import FavoritesStrip from "@/pages/home/components/FavoritesStrip";
import StationIntro from "@/pages/home/components/StationIntro";

export default function Home() {
  const location = useLocation();

  useSeo({
    title: "一路向西影视作品大全与剧情介绍平台",
    description:
      "一路向西官网提供全面的影视作品资讯，包括剧情介绍、角色分析及最新影视动态，满足用户对一路向西相关内容的深入了解与观看需求。",
    keywords: "一路向西,影视作品,剧情介绍,电影资讯,电视剧,影视动态,角色分析",
  });

  useEffect(() => {
    if (location.hash === "#specials") {
      const target = document.getElementById("specials");
      if (target) {
        window.requestAnimationFrame(() => target.scrollIntoView({ behavior: "smooth", block: "start" }));
      }
    }
  }, [location.hash, location.key]);

  return (
    <>
      <HeroCarousel />
      <CategoryEntries />
      <FeaturedSection />
      <NewsSection />
      <SpecialsSection />
      <FavoritesStrip />
      <StationIntro />
    </>
  );
}